import { sessionService } from "../services/sessionService";

export function authHeader() {
  const id = sessionService.getSessionId();

  if (id) {
    return { session: id };
  } else {
    return {};
  }
}
